import type { FunctionComponent } from 'react';
import type { BlockType } from '../../types';
import { BadgeBlock } from './badge';
import { ButtonBlock } from './button';
import { CouponBlock } from './coupon';
import { FormBlock } from './form';
import { HeadingBlock } from './heading';
import { HtmlBlock } from './html';
import { IframeBlock } from './iframe';
import { ImageBlock } from './image';
import { LinkBlock } from './link';
import { SeparatorBlock } from './separator';
import { SpacingBlock } from './spacing';
import { TextBlock } from './text';
import { TimerBlock } from './timer';
import { VideoBlock } from './video';

export const blockComponents: BlockComponents = {
  badge: BadgeBlock,
  button: ButtonBlock,
  form: FormBlock,
  image: ImageBlock,
  heading: HeadingBlock,
  video: VideoBlock,
  text: TextBlock,
  coupon: CouponBlock,
  link: LinkBlock,
  separator: SeparatorBlock,
  spacing: SpacingBlock,
  iframe: IframeBlock,
  html: HtmlBlock,
  timer: TimerBlock
};

export type BlockComponents = Record<BlockType, FunctionComponent<any>>;
